<mat-card class="height-100">
  <mat-card-header>
    <mat-card-title>
      Adicionar fabricante
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab label="Dados" style="flex: 1;">
        <ng-template mat-tab-label>
          Dados
          <i
            *ngIf="formDadosValid"
            class="mdi mdi-alert-circle red"
            matTooltip="Preencha as informações corretamente"
          ></i>
        </ng-template>

        <app-fast-parceiro
          [entity]="entity"
          [entityService]="fabricanteService"
          (onLoadParceiro)="setInformacoesParceiro($event)"
        ></app-fast-parceiro>
      </mat-tab>
      <mat-tab label="Endereço" style="flex: 1;">
        <ng-template mat-tab-label>
          Endereço
          <i
            *ngIf="formAddressValid"
            class="mdi mdi-alert-circle red"
            matTooltip="Preencha as informações corretamente"
          ></i>
        </ng-template>
        <app-fast-endereco [entity]="entity.parceiro"></app-fast-endereco>
      </mat-tab>
      <mat-tab label="Contatos">
        <app-fast-contato [entity]="entity.parceiro"></app-fast-contato>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
  <mat-card-actions>
    <div class="row m-0 pb-2">
      <div class="col-md-12" style="display: flex; justify-content: flex-end;">
        <button mat-stroked-button color="warn" [matDialogClose]="undefined">
          Cancelar
        </button>
        <button
          mat-raised-button
          color="primary"
          (click)="onSubmit()"
          [disabled]="!formValid"
        >
          Cadastrar
        </button>
      </div>
    </div>
  </mat-card-actions>
</mat-card>
